import type { VideoHTMLAttributes } from 'react';
import type { OnMediaLoadingProps } from '../../../../common/types/types';
import { Z_INDEX_LAYERS } from '../../constants';
type GetSignedUrlT = () => Promise<string | undefined>;
export type VideoProps = {
  // Core
  id: string;
  disablePointerEvents: boolean;
  brightness: number;
  contrast: number;
  onVideoElementRefChange?: (element: HTMLVideoElement | null) => void;

  // Media playback info
  src: string;
  mediaFrameRate?: number;
  videoType: string; // defaults to 'video/mp4'
  playbackRate: number | null;
  volume: number | null;
  isPlaying: boolean | null;

  // Frame mapping / seek
  currentFrame: number | null; // required for both main & thumbnail
  getTimeFromFrameNumber: ((frame: number) => number) | null;
  getFrameNumberFromTime: ((time: number) => number) | null;

  // Events
  onFrameLoadStatus: (frameNumber: number) => void;
  onLoadedMetadata: (duration: number, el: HTMLVideoElement | null) => void;
  onDimensionChange: (w: number, h: number) => void;
  onEndToLastFrame: () => void;
  fitToScreen: () => void;
  onLoading: (props: OnMediaLoadingProps) => void;
  onError: (error: Error) => void;

  // Lifecycle
  onSrcChange: (src: string) => void;
  onLoad: () => void;
  onLoadStart?: (videoUrl: string) => void;

  // Performance (optional)
  fetchFileSizeAndFormat?: (src: string) => Promise<{
    fileSize: number | null;
    format: string | null;
  }>;

  // Signed URL utils
  getSignedUrl: GetSignedUrlT | null;
  srcExpirationDuration: number | null;
} & Omit<VideoHTMLAttributes<HTMLVideoElement>, 'src' | 'id' | 'onLoad' | 'onError' | 'onLoadStart'>;
export const VIDEO_OVERLAY_LAYER_Z_INDEX = Z_INDEX_LAYERS.THREE;